import { EyedropperIcon } from './EyedropperIcon';

/**
 * author: Austin Andrews
 * id 89350468-16D8-4F39-AA78-C3E00EE8FB2C
 * name eyedropper
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eyedropper.svg
 * tags
 * - Color 
 * - Drawing / Art 
 * - Science 
 */
export const PipetteIcon = EyedropperIcon;
export default PipetteIcon